import request from '@/utils/request'

// 品类
export function ApiCoursewareCate() {
  return request({
    url: '/api/Topic/GetCoursewareCate',
    method: 'get',
  })
}

// 课程市场
export function ApiCourseware(params) {
  return request({
    url: '/api/Topic/GetCourseware',
    method: 'get',
    params
  })
}

// 我的课程
export function ApiMyCourseware(params) {
  return request({
    url: '/api/Topic/GetMyCourseware',
    method: 'get',
    params
  })
}

// 课程详情
export function ApiCoursewareDetail(params) {
  return request({
    url: '/api/Topic/GetCoursewareDetail',
    method: 'get',
    params
  })
}

// 课程下的课节列表
export function TopicGetDetail(params) {
  return request({
    url: '/api/Topic/GetDetail',
    method: 'get',
    params
  })
}

// 解析vod视频地址
export function GetVodPlayUrl(params) {
  return request({
    url: '/phone/Index/GetVodPlayUrl',
    method: 'get',
    params
  })
}

// sts 获取临时token
export function GetVodStsToken() {
  return request({
    url: 'api/AliYun/GetVodStsToken',
    method: 'get',
  })
}

// 创建订单
export function ApiCoursewareOrderCreate(data) {
  return request({
    url: '/api/CoursewareOrder/Create',
    method: 'POST',
    data
  })
}

// 鱼支付
export function ApiCoursewareOrderFishPay(data) {
  return request({
    url: '/api/CoursewareOrder/FishPay',
    method: 'POST',
    data
  })
}

/**
 * 根据支付记录号生成收钱吧支付Url
 * @param {object} data
 */
 export function tradeNoWoSaiPay(data) {
  return request({
    url: "/common/pay/GenerateTradeNoWoSaiPayUrl",
    method: "post",
    data
  })
}

/**
 * 获取收益列表
 */
 export function coursewareOrderGetUserProfit(params) {
  return request({
    url: "/api/CoursewareOrder/GetUserProfit",
    method: "get",
    params
  })
}

/**
 * 添加提现申请
 */
 export function UserWithdrawalApplyAdd(data) {
  return request({
    url: "/api/UserWithdrawalApply/Add",
    method: "POST",
    data
  })
}

/**
 * 获取我的提现列表
 */
 export function UserWithdrawalApplyMyList(params) {
  return request({
    url: "/api/UserWithdrawalApply/MyList",
    method: "GET",
    params
  })
}